import React, { useState } from 'react';
import ProgressRing from './ProgressRing';

const HabitCard = ({ habit, onToggle, onDelete }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDelete = () => {
    onDelete(habit.id);
    setShowDeleteModal(false);
  };

  return (
    <>
      <div className={`bg-white/90 backdrop-blur-sm rounded-xl shadow-md p-6 border border-white/30 hover:shadow-lg transition-all duration-300 transform hover:scale-[1.02] ${
        habit.completedToday ? 'bg-green-50/90 border-green-200' : ''
      }`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="flex-shrink-0">
              <ProgressRing />
            </div>
            <div>
              <h4 className={`text-lg font-bold text-gray-800 transition-all duration-200 ${
                habit.completedToday ? 'line-through text-gray-500' : ''
              }`}>
                {habit.name}
              </h4>
              <p className="text-sm font-medium text-orange-600">
                🔥 {habit.streak || 0}-day streak
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={() => onToggle(habit.id)}
              className={`px-6 py-3 rounded-lg font-semibold transition-all duration-200 transform hover:scale-105 ${
                habit.completedToday
                  ? 'bg-gray-300 text-gray-600 cursor-not-allowed shadow-sm'
                  : 'bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:from-green-600 hover:to-emerald-700 shadow-md hover:shadow-lg'
              }`}
              disabled={habit.completedToday}
            >
              {habit.completedToday ? 'Done ✅' : 'Mark as Done'}
            </button>
            <button
              onClick={() => setShowDeleteModal(true)}
              className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-all duration-200"
              title="Delete habit"
            >
              🗑️
            </button>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl p-6 max-w-md w-full">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Delete Habit</h3>
            <p className="text-gray-600 mb-6">
              Are you sure you want to delete "{habit.name}"? This action cannot be undone.
            </p>
            <div className="flex space-x-3">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors duration-200 font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200 font-medium"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HabitCard;
